module.exports = __webpack_public_path__ + "img/gl-logo.aafdfbdb.png";